import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { Btn } from "../components/Button";
import {
  deleteArt,
  getAllArts,
  getUserByDocument,
  updateArt,
} from "../lib/actions";
import { toast } from "sonner";
import {
  DeleteConfirmationModal,
} from "../components/modals/Modals";
import { Query } from "appwrite";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 80%;
  min-height: 50vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const Container2 = styled.div`
  width: 80%;
  min-height: 130vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    color: orange;
  }
  .text-3 {
    color: red;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
  }
  @media (max-width: 40em) {
    width: 90%;
  }
`;

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
  p span {
    color: orange;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const Div2 = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 50px;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
  button {
    margin: 10px 0;
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 85%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const UserTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 30px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
    color: ${(props) => props.theme.text};
    img {
      width: 150px;
      margin-: 0px auto;
    }
  }

  th {
    background-color: ${(props) => props.theme.body};
    font-weight: bold;
  }

  tr:nth-child(even) {
    background-color: ${(props) => props.theme.bodyRgba};
  }

  tr:hover {
    background-color: ${(props) => props.theme.bodyRgba};
  }

  @media (max-width: 48em) {
    font-size: 14px;
    th,
    td {
      padding: 8px;
    }
  }
`;

const ActionsContainer = styled.div`
  width: auto;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
  align-items: start;
`;

const ManageArts = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [arts, setArts] = useState([]);
  const [user, setUserData] = useState([]);
  const [updatingArtId, setUpdatingArtId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("userId");
    setIsLoggedIn(!!token);
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const raw = localStorage.getItem("userId");
        if (raw) {
          const id = JSON.parse(raw);
          const userData = await getUserByDocument(id);
          setUserData(userData);
          const allUsers = await getAllArts([Query.equal("minted", false)]);
          console.log(allUsers)
          setArts(allUsers);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUser();
  }, []);

  const handleOpenDelete = (user) => {
    setSelectedUser(user);
    setIsDeleteModalOpen(true);
  };

  const MintArt = async (updatedArt) => {
    try {
      console.log("Minting Art:", updatedArt);
      setUpdatingArtId(updatedArt.$id);
      await updateArt(updatedArt.$id, { minted: true });
      const allUsers = await getAllArts([Query.equal("minted", false)]);
      setArts(allUsers);
      toast.success("Art Minted Successfully!");
    } catch (error) {
      toast.error("Error Minting Art");
    } finally {
      setUpdatingArtId(null);
    }
  };

  const DeleteArt = async (artToDelete) => {
    try {
      await deleteArt(artToDelete.$id);
      setIsDeleteModalOpen(false);
      const allUsers = await getAllArts([Query.equal("minted", false)]);
      setArts(allUsers);
      toast.success("User deleted!");
    } catch (error) {
      toast.error("Error deleting user");
    }
  };

  const Actions = ({ onUpdate, onDelete, isUpdating }) => (
    <ActionsContainer>
      <Btn onClick={onUpdate} disabled={isUpdating}>
        {isUpdating ? "Minting..." : "MINT..."}
      </Btn>
      <Btn onClick={onDelete}>DELETE</Btn>
    </ActionsContainer>
  );

  return (
    <Section id="users">
      <Navigation />
      {isLoggedIn && user.role === "admin" ? (
        <Container2>
          <Title>Trade Millennia Users</Title>
          <p style={{ marginTop: "20px" }}>
            Total Count of unminted arts : {arts.length}
          </p>

          <UserTable>
            <thead>
              <tr>
                <th>ID</th>
                <th>Art Image</th>
                <th>Owners Email</th>
                <th>Art Names</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {arts.map((art, index) => (
                <tr key={art.id}>
                  <td>{art.$id}</td>
                  <td>
                    <img src={art.img} alt={art.name} width="80" />
                  </td>
                  <td>{art.userId?.email ?? "No email"}</td>
                  <td>{art.name}</td>
                  <td>
                    <Actions
                      onUpdate={() => MintArt(art)}
                      onDelete={() => handleOpenDelete(art)}
                      isUpdating={updatingArtId === art.$id}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </UserTable>

          {isDeleteModalOpen && selectedUser && (
            <DeleteConfirmationModal
              user={selectedUser}
              onClose={() => setIsDeleteModalOpen(false)}
              onConfirm={DeleteArt}
            />
          )}
        </Container2>
      ) : (
        <Container>
          <Div>
            <Title>
              <span>Create Your</span> <span className="text-3">Art</span>
            </Title>
            <p>
              <Link to="/">Home</Link>
              <span> . Create</span>
            </p>
          </Div>

          <Div2>
            <p> Please connect your wallet to view this page </p>
            <Link to="/connect-wallet">
              <button>Connect Wallet</button>
            </Link>
          </Div2>
        </Container>
      )}
      <Footer />
    </Section>
  );
};

// export default ManageArts;

export default ManageArts;
